import React, { useEffect, useMemo, useState } from "react";
import { getPersonalMessageGatewayLogs } from "../../features/messageLogApi";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { badge } from "../../components/common/Utils";
import moment from "moment";
import Table from "../../components/table/Table";

const Gateway = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const gatewayLogs = useSelector((state) => state?.messageLog?.gatewayLog);

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getPersonalMessageGatewayLogs(dispatch, setIsLoading);
  }, []);

  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "13%",
        Header: t("mobile"),
        accessor: "mobile",
      },
      {
        width: "9%",
        Header: t("status"),
        accessor: "status",
        Cell: ({ cell: { value } }) => {
          return badge(value);
        },
      },
      {
        width: "8%",
        Header: t("type"),
        accessor: "type",
        Cell: ({ cell: { value } }) => {
          return <div className="text-center">{badge(value)}</div>;
        },
      },
      {
        width: "8%",
        Header: t("count"),
        accessor: "count",
        Cell: ({ cell: { value } }) => {
          return <div className="text-center">{value}</div>;
        },
      },
      {
        width: "12%",
        Header: t("createdAt"),
        accessor: "createdAt",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("MMM DD YYYY hh:mm A");
        },
      },
      {
        width: "45%",
        Header: t("message"),
        accessor: "messageText",
        // Cell: ({ row: { original } }) => {
        //   return (
        //     <div>
        //       {original.message && original.message.slice(0, 80)}
        //       <span
        //         className="text-primary see-more"
        //         onClick={() => {
        //           setFixedId(original._id);
        //           setModalShow({ ...modalShow, [false]: true });
        //         }}
        //       >
        //         {original.message.length > 80 ? "...see more" : ""}
        //       </span>
        //     </div>
        //   );
        // },
      },
    ],
    [t],
  );

  return (
    <>
      <Table isLoading={isLoading} columns={columns} data={gatewayLogs} />
    </>
  );
};

export default Gateway;
